export default __webpack_public_path__ + "static/media/point.307ec9d8.svg";